export const pagelimits = [20, 50, 100, 200];
export let pagelimitsLarge = [10, 25, 100, 500, 1000, 1500];

 export const labels = [
    {
        id   : 'b167d3c4-f6ed-4ea6-9579-a12f95a9d76e',
        title: 'Draft',
        slug : 'draft',
        color: 'gray',
    },
    {
        id   : '745cf30e-ca84-47a1-a553-b70eb630d8e7',
        title: 'In Review',
        slug : 'in review',
        color: 'orange',
    },
    {
        id   : '8b035cb5-65c0-4ab1-bb4c-43b0e442d1f3',
        title: 'Final',
        slug : 'final',
        color: 'blue',
    },
    {
        id   : 'b2d1e4e7-7cfd-4b51-ae59-217a093df754',
        title: 'Accepted',
        slug : 'accepted',
        color: 'green',
    },
    {
        id   : '184cd689-4ee4-47cf-9f8a-12233d614326',
        title: 'Rejected',
        slug : 'rejected',
        color: 'red',
    }
];

export const labelColors = [
    'gray',
    'red',
    'orange',
    'yellow',
    'green',
    'teal',
    'blue',
    'indigo',
    'purple',
    'pink',
];

export const labelColorDefs = {
    gray  : {
        text    : 'text-gray-500',
        bg      : 'bg-gray-500',
        combined: 'text-gray-800 bg-gray-100',
    },
    red   : {
        text    : 'text-red-500',
        bg      : 'bg-red-500',
        combined: 'text-red-800 bg-red-100',
    },
    orange: {
        text    : 'text-orange-500',
        bg      : 'bg-orange-500',
        combined: 'text-orange-800 bg-orange-100',
    },
    yellow: {
        text    : 'text-yellow-500',
        bg      : 'bg-yellow-500',
        combined: 'text-yellow-800 bg-yellow-100',
    },
    green : {
        text    : 'text-green-500',
        bg      : 'bg-green-500',
        combined: 'text-green-800 bg-green-100',
    },
    teal  : {
        text    : 'text-teal-500',
        bg      : 'bg-teal-500',
        combined: 'text-teal-800 bg-teal-100',
    },
    blue  : {
        text    : 'text-blue-500',
        bg      : 'bg-blue-500',
        combined: 'text-blue-800 bg-blue-100',
    },
    indigo: {
        text    : 'text-indigo-500',
        bg      : 'bg-indigo-500',
        combined: 'text-indigo-800 bg-indigo-100',
    },
    purple: {
        text    : 'text-purple-500',
        bg      : 'bg-purple-500',
        combined: 'text-purple-800 bg-purple-100',
    },
    pink  : {
        text    : 'text-pink-500',
        bg      : 'bg-pink-500',
        combined: 'text-pink-800 bg-pink-100',
    },
};

export const roles  = [

    {
        value      : 'READ',
        description: 'Can view and download files and folders.',
    },
    {
        value      : 'WRITE',
        description: 'Can view, download, upload, and edit files and folders.',
    },
    {
        value      : 'ADMIN',
        description: 'Full control of files and folders, including managing sharing, permissions, and settings.',
    },
];

export const accessLevel  = [
    {
        value      : 'VIEWER',
        description: 'Can view and download files and folders.',
    },
    {
        value      : 'WRITER',
        description: 'Can view, download, upload, and edit files and folders.',
    },
    {
        value      : 'OWNER',
        description: 'Full control of files and folders, including managing sharing, permissions, and other people\'s access.',
    },

    {
        value : 'Remove access',
        description: 'Remove record from people access.'
    }
];

 // Setup available panels
 export const userPanels = [
    {
        id         : 'account',
        icon       : 'heroicons_outline:user-circle',
        title      : 'My Profile',
        description: 'Manage your system profile and contact information',
    },
    {
        id         : 'security',
        icon       : 'heroicons_outline:lock-closed',
        title      : 'Security',
        description: 'Manage your password and security settings',
    },
    {
        id         : 'notifications',
        icon       : 'heroicons_outline:bell',
        title      : 'Notifications',
        description: 'Manage when you\'ll be notified on which triggers and modes',
    },
    {
        id         : 'preferences',
        icon       : 'heroicons_outline:presentation-chart-bar',
        title      : 'Preferences',
        description: 'Customize the look and feel of the system for your session',
    },

];

export const menuLabels = {
    Viewer  : {
        value  : 'READ',
    },

    Editor  : {
        value  : 'WRITE',
    },

    ADMIN  : {
        value  : 'ADMIN',
    },

    remove  : {
        value  : 'Remove access',
    },

}

export const iconTypes = [
    'aep',
    'ai',
    'avi',
    'css',
    'csv',
    'dll',
    'doc',
    'docx',
    'dwg',
    'eps',
    'exe',
    'fileserror',
    'filespreview',
    'filespreviewfail',
    'flv',
    'gif',
    'html',
    'indd',
    'iso',
    'jpg',
    'js',
    'mov',
    'mp3',
    'mp4',
    'pdf',
    'php',
    'png',
    'ppt',
    'pptx',
    'premierepro',
    'procreate',
    'psd',
    'raw',
    'rar',
    'rtf',
    'svg',
    'tiff',
    'txt',
    'wav',
    'xls',
    'xlsx',
    'zip',
    '7z',
];

export const themes = [
    {
        id  : 'theme-default',
        name: 'Default',
    },
    {
        id  : 'theme-brand',
        name: 'Brand',
    },
    {
        id  : 'theme-teal',
        name: 'Teal',
    },
    {
        id  : 'theme-rose',
        name: 'Rose',
    },
    {
        id  : 'theme-purple',
        name: 'Purple',
    },
    {
        id  : 'theme-amber',
        name: 'Amber',
    },
    {
        id  : 'theme-lolly',
        name: 'Lolly',
    },
]

export const USER_TYPE_QUERY_MAPPING = {
    'EXT':'E',
    'LPM':'L',
  }

export const DMS_MAX_FILE_SIZE_MB = 5120; // 5 GB in MB

export const DMS_MAX_FILE_SIZE_BYTES = DMS_MAX_FILE_SIZE_MB * 1024 * 1024;
